import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@services/core/user.service';
import { EntityService } from '@services/core/entity.service';
import { ModuleService } from '@services/core/module.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export const usersManagementResolver: ResolveFn<any> = () => {
  const userService = inject(UserService)
  const entityService = inject(EntityService)
  const moduleService = inject(ModuleService)
  return fetchManagement(userService, entityService, moduleService)
}

function fetchManagement(userService: UserService, entityService: EntityService, moduleService: ModuleService) {
  return forkJoin({
    roles: userService.getRoles(),
    offices: entityService.getOffices(),
    entities: entityService.getEntities(),
    modules: moduleService.getActiveModules()
  }).pipe(
    map((data) => buildManagement(data))
  )
}

function buildManagement(data: any) {
  return packManagement(data);
}

function packManagement(data: any) {
  return {
    roles: data.roles,
    offices: data.offices,
    entities: data.entities,
    modules: data.modules
  };
}
